import React from 'react';

import {NoResultPage} from 'src/modules/entitlements';
import {SIZES} from 'src/modules/profile/user/tabs/content/constants';
import {CollaboratorRoleHeader} from 'src/modules/profile/user/tabs/content/workspace/headers/collaborator-role-header';
import {CreatedHeader} from 'src/modules/profile/user/tabs/content/workspace/headers/created-header';
import {LastUpdatedHeader} from 'src/modules/profile/user/tabs/content/workspace/headers/last-updated-header';
import {WorkspaceHeader} from 'src/modules/profile/user/tabs/content/workspace/headers/workspace-header';
import {WorkspaceTableRow} from 'src/modules/profile/user/tabs/content/workspace/workspace-table-row';
import {WorkspaceDetails} from 'src/openapi/admin/models/WorkspaceDetails';
import {WorkspaceGeneralInfo} from 'src/openapi/admin/models/WorkspaceGeneralInfo';
import {WorkspaceRequest} from 'src/openapi/admin/models/WorkspaceRequest';

import {Group} from '@pb/kit-component-group';
import {PaginationStripe} from '@pb/kit-component-pagination';
import Table, {Body, Cell, Head, Row} from '@pb/kit-component-table';

type Props = {
    userId: number,
    workspaceDetailsData: {[key: string]: WorkspaceDetails},
    isNoCreatedWorkspaces: boolean,
    data: WorkspaceGeneralInfo[],
    total: number,
    setPage: (page: number) => void,
    setPageSize: (size: number) => void,
    criteria: WorkspaceRequest,
};

export const WorkspaceTable = (props: Props) => {
    const {userId, workspaceDetailsData, isNoCreatedWorkspaces, data, total, setPage, setPageSize, criteria} = props;

    return (
        <Group gap="m" direction="v">
            <Table fixed={true} align="middle">
                <Head>
                    <WorkspaceHeader/>
                    <Cell>Description</Cell>
                    <CollaboratorRoleHeader/>
                    <LastUpdatedHeader/>
                    <CreatedHeader/>
                    <Cell width={60}/>
                </Head>

                <Body>
                    {total > 0 ?
                            data.map((item: WorkspaceGeneralInfo, i: number) => (
                                <WorkspaceTableRow
                                    key={'key' + item.workspaceId}
                                    workspaceId={item.workspaceId}
                                    workspace={item}
                                    workspaceDetails={workspaceDetailsData[item.workspaceId]}
                                    showZebra={i % 2 === 0}
                                    userId={userId}
                                />
                            )) : (
                                <Row>
                                    <Cell colSpan={6} className="text-align_center">
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            padding: '20px 0',
                                        }}>
                                            <NoResultPage
                                                title="No data to show"
                                                description={isNoCreatedWorkspaces
                                                    ? 'This user has not created any workspaces yet.'
                                                    : 'No data found for the selected criteria.'}
                                            />
                                        </div>
                                    </Cell>
                                </Row>
                            )}
                </Body>
            </Table>
            <PaginationStripe
                totalCount={total}
                currentPage={criteria?.pagination?.currentPage || 1}
                pageSize={criteria?.pagination?.pageSize || 7}
                onPaginationChange={p => setPage(p.currentPage)}
                showSizeSwitcher={true}
                goToPage={true}
                sizeSwitcherPosition="RIGHT"
                sizes={SIZES}
                onChangePaginationSize={(_p, size) => setPageSize(size)}
            />
        </Group>
    );
};
